module.exports = __webpack_public_path__ + "static/media/perfil.3d7af0dd.jpeg";